import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Claim } from "../model/claim";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { ImageAccessUrlViewModel } from "../model/ImageAccessUrlViewModel";

@Injectable()
export class ClaimService {
  constructor(
    private http: GlobalService,
    private entityService: EntityService
  ) { }

  getById(id: number): Observable<Claim> {
    const url = `claims/${id}`;
    return this.http
      .get(url)
      .map((res) => this.entityService.extractData<Claim>(res))
      .map((dataItem) => this.entityService.copy(dataItem, new Claim()));
  }

  getAll(): Observable<Claim[]> {
    const url = `claims`;
    return this.http
      .get(url)
      .map((res) => this.entityService.extractData<Claim[]>(res))
      .map((data) => {
        return data.map((dataItem) => {
          const claim = new Claim();
          return this.entityService.copy(dataItem, claim);
        });
      });
  }


  GetImageAccessUrl(id: number): Observable<ImageAccessUrlViewModel> {

    const url = `claims/${id}/access-url`;

    return this.http
      .get(url)
      .map(res => this.entityService.extractData<any>(res))
      .map(data => {
        const result = new ImageAccessUrlViewModel();
        result.url = data.url;
        result.expiresOn = data.expiresOn;
        result.isPrivate = data.isPrivate;
        return result;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/claim.service.ts